import React, { FC, useEffect } from "react";

import { useTracking } from "../../../../stores/tracking";

export type TrackingProps = {
    appParameter: {
        value?: string;
        onlyIfEmpty: boolean;
    };
};

const AppParameter: FC<TrackingProps["appParameter"]> = ({
    value: newValue,
    onlyIfEmpty,
}) => {
    const { currentValue, setAppParameter } = useTracking(
        ({ app, setAppParameter }) => ({
            currentValue: app.parameter,
            setAppParameter,
        })
    );
    useEffect(() => {
        if (
            newValue !== undefined &&
            (!onlyIfEmpty || currentValue === undefined)
        ) {
            setAppParameter(newValue);
        }
    }, [setAppParameter, currentValue, newValue, onlyIfEmpty]);

    return null;
};

const Tracking: FC<TrackingProps> = ({ appParameter }) => (
    <AppParameter {...appParameter} />
);
export default Tracking;
